import { apiClient } from '@/lib/api-client';
import type { BusinessLine, CreateBusinessLineInput, UpdateBusinessLineInput } from '../types';

const BASE = '/crm/business-lines';

/** Inventory M6 (v1.4 FR-21/FR-35): starter-pack gallery + apply. */
export interface StarterPackPreview {
  key: string;
  title: string;
  description: string;
  hierarchyLabels: string[] | null;
  statuses: { name: string; semantic: string; color: string }[];
  fields: { label: string; fieldType: string }[];
}

export interface ApplyPackResult {
  packKey: string;
  statusesCreated: number;
  statusesSkipped: number;
  fieldsCreated: number;
  fieldsSkipped: number;
  labelsSet: boolean;
}

export const businessLinesApi = {
  list: async (activeOnly = true): Promise<BusinessLine[]> => {
    return apiClient.get<BusinessLine[]>(`${BASE}?activeOnly=${activeOnly}`);
  },

  getById: async (id: string): Promise<BusinessLine> => {
    return apiClient.get<BusinessLine>(`${BASE}/${id}`);
  },

  create: async (data: CreateBusinessLineInput): Promise<BusinessLine> => {
    return apiClient.post<BusinessLine>(BASE, data);
  },

  update: async (id: string, data: UpdateBusinessLineInput): Promise<BusinessLine> => {
    return apiClient.patch<BusinessLine>(`${BASE}/${id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    return apiClient.delete(`${BASE}/${id}`);
  },

  packs: async (): Promise<StarterPackPreview[]> => {
    return apiClient.get<StarterPackPreview[]>(`${BASE}/packs`);
  },

  applyPack: async (id: string, packKey: string): Promise<ApplyPackResult> => {
    return apiClient.post<ApplyPackResult>(`${BASE}/${id}/apply-pack`, { packKey });
  },
};
